<div class="loading-overlay" *ngIf="display">
    <div class="d-flex justify-content-center ">
        <div class="spinner-border text-warning " role="status">
            <span class="sr-only ">Loading...</span>
        </div>
    </div>
</div>